import type { PermissionRule } from './types';

export const permissionRegistry = {
  'broadcastQueue.manageMode': {
    allowSuperAdmin: true,
    anyOf: ['admin:write'],
  },
  'broadcastQueue.approveSelected': {
    anyOf: ['campaigns:write', 'campaigns:execute'],
  },
  'broadcastQueue.approveAll': {
    anyOf: ['campaigns:execute'],
  },
  'broadcastQueue.changeChannel': {
    anyOf: ['campaigns:update', 'campaigns:write'],
  },
} as const satisfies Record<string, PermissionRule>;

export type AppPermissionCapability = keyof typeof permissionRegistry;
